export default __webpack_public_path__ + "static/media/forma-zayavki.172c45e5.pdf";